import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Reading from './views/Reading.vue'
import Gaming from './views/Gaming.vue'
import Watching from './views/Watching.vue'
import AddBook from './components/AddBook.vue'
import AddGame from './components/AddGame.vue'
import AddProgram from './components/AddProgram.vue'
import EditBook from './components/EditBook.vue'
import EditGame from './components/EditGame.vue'
import EditProgram from './components/EditProgram.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/reading',
      name: 'Reading',
      component: Reading
    },
    {
      path: '/gaming',
      name: 'Gaming',
      component: Gaming
    },
    {
      path: '/watching',
      name: 'Watching',
      component: Watching
    },
    {
      path: '/reading/add-book',
      name: 'AddBook',
      component: AddBook
    },
    {
      path: '/gaming/add-game',
      name: 'AddGame',
      component: AddGame
    },
    {
      path: '/watching/add-program',
      name: 'AddProgram',
      component: AddProgram
    },
    {
      path: '/reading/edit-book/:book_slug',
      name: 'EditBook',
      component: EditBook
    },
    {
      path: '/gaming/edit-game/:game_slug',
      name: 'EditGame',
      component: EditGame
    },
    {
      path: '/watching/edit-program/:program_slug',
      name: 'EditProgram',
      component: EditProgram
    }
  ]
})
